import React, { useEffect, useRef, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import './dashboard.scss';
import { useQuery } from '@tanstack/react-query';
import axios from '../../api/axios';
import { destroySession } from '../../helpers/Session';
import { useNavigate } from 'react-router-dom';
import { useSidebarData } from '../../hooks/sidebarData';
import './popover.scss'; 

const Dashboard = () => {
    const navigate = useNavigate();
    const { setSidebarData } = useSidebarData();
    const localizer = momentLocalizer(moment);

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';

    // State for current month
    const [currentMonth, setCurrentMonth] = useState(moment().startOf('month').format('YYYY-MM-DD'));

    const { data: events, error: errorEvents, refetch } = useQuery({
        queryKey: ['events', currentMonth], // Dependency on the currentMonth
        queryFn: async () => {
            const res = await axios.get(`/dashboard/calendar?department=${departmentslug}&month=${currentMonth}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            const eventsWithDates = res.data?.response.map(event => ({
                ...event,
                start: new Date(event.start),
                end: new Date(event.end),
                style: {
                    backgroundColor: event.backgroundColor,
                    color: event.color,
                }
            }));
            return eventsWithDates;
        },
        enabled: !!departmentslug && !!accesstoken,
        retry: 1
    });

    useEffect(() => {
        if (errorEvents) {
            if (errorEvents.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error') }, 1000);
            }
        }
    }, [errorEvents]);

    const handleViewLeaveRequest = (leave, leaveid, uname) => {
        setSidebarData('state', true);
        setSidebarData('key', 'leave-request');
        setSidebarData('label', `${leave}`);
        setSidebarData('data', {
            uname,
            leaverequestid: leaveid
        });
    };

    const handleViewEventDetails = (event, date) => {
        setSidebarData('state', true);
        setSidebarData('key', 'event');
        setSidebarData('label', 'Event Details');
        setSidebarData('data', {
            event,
            date: moment(date).format('MMMM D, YYYY')
        });
    };

    // Handle month navigation (previous/next month)
    const handleNavigate = (date) => {
        const newMonth = moment(date).startOf('month').format('YYYY-MM-DD');
        setCurrentMonth(newMonth);  // Update the current month
        refetch(); // Refetch the events for the new month

        // close sidebar
        setSidebarData('state', false);
        setSidebarData('key', '');
        setSidebarData('label', '');
        setSidebarData('data', []);
    };

    return (
      <div className="dashboard">
        <div className="panels">
          <div className="left-panel">
            <div className="calendar">
              <Calendar
              localizer={localizer}
              events={events || []}
              startAccessor="start"
              endAccessor="end"
              popup
              onSelectEvent={(event) => {
                if (event.leaveid !== '') {
                  handleViewLeaveRequest(event.title, event.leaveid, event.uname);
                } else {
                  handleViewEventDetails(event.title, event.start);
                }
              }}
              onNavigate={handleNavigate}
              eventPropGetter={(event) => {
                return {
                  style: {
                    backgroundColor: event.style?.backgroundColor || '#f0f0f0',
                    color: event.style?.color || '#333',
                    '--event-border-color': event.style?.backgroundColor || '#007bff',
                    '--event-text-color': event.style?.color || '#333',
                  },
                };
              }}
            />
            </div>
          </div>

          {/* <div className='right-panel'>
                    <div className='recent-activity'>
                        <div className='header'>
                            <h3>Recent Activity</h3>
                        </div>
                    </div>
                </div> */}
        </div>
      </div>
    );
};

export default Dashboard;
